import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/problems/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/problems/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/problems/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/problems/delete/${id}`)
}
